import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=1dbe68ca&lang=scss&scoped=true"

import exportComponent from "D:\\PHPStudio\\xampp_old2\\htdocs\\office_studio\\2026\\agustus\\frontend-olsera-open-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbe68ca"]])

export default __exports__